module.exports = __webpack_public_path__ + "img/sbp-slider4.fa4262b1.png";